import { render, staticRenderFns } from "./SubmitRequestModal.vue?vue&type=template&id=8176c020&"
import script from "./SubmitRequestModal.vue?vue&type=script&lang=ts&"
export * from "./SubmitRequestModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports